<mat-expansion-panel [expanded]="initialExpanded" (opened)="toggleExpanded()" (closed)="toggleExpanded()">
    <mat-expansion-panel-header>
        <mat-panel-title>CODING
            <button mat-icon-button [matMenuTriggerFor]="exportMenu" class="m-l-10 m-b-5" *ngIf="!stateUnit"
                matTooltip="Export coding for this patient">
                <mat-icon>outgoing_mail</mat-icon>
            </button>
            <mat-menu #exportMenu="matMenu">
                <button mat-menu-item (click)="exportBilling('docx')">
                    <mat-icon>description</mat-icon>
                    <span>Export as Word</span>
                </button>
                <button mat-menu-item (click)="exportBilling('xlsx')">
                    <mat-icon>table_chart</mat-icon>
                    <span>Export as Excel</span>
                </button>
            </mat-menu>
            <button mat-icon-button
                *ngIf="connectFeatureEnabled && group?.connectEnabled && group?.connectTenantId"
                [disabled]="isSubmitting" (click)="submitToConnect()" class="m-l-10 m-b-5"
                matTooltip="Submit this patient's coding to Connect">
                <mat-icon>cloud_upload</mat-icon>
            </button>
            <button mat-icon-button [matMenuTriggerFor]="statusFilterMenu"
                (click)="$event.stopPropagation()" class="m-l-10 m-b-5"
                [color]="statusFilters ? 'accent' : ''"
                matTooltip="Filter coding">
                <mat-icon>filter_list</mat-icon>
            </button>
            <mat-menu #statusFilterMenu="matMenu" class="filter-menu">
                <div mat-menu-content class="filter-menu-content" (click)="$event.stopPropagation()">
                    <div class="filter-options">
                        <h4>Filter Coding</h4>
                        <mat-radio-group [(ngModel)]="statusFilters" class="status-filter-radios">
                            <mat-radio-button [value]="''">All</mat-radio-button>
                            <mat-radio-button *ngFor="let sf of availableStatusFilters" [value]="sf.value">
                                {{ sf.label }}
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
            </mat-menu>
        </mat-panel-title>

        <mat-panel-description class="coding-summary"
            *ngIf="connectFeatureEnabled && group?.connectEnabled && group?.connectTenantId && billingSummary.hasData">
            <span class="summary-metric"><span class="label">Scheme</span>{{ formatCents(billingSummary.schemeCents) }}</span>
            <span class="summary-metric"><span class="label">Patient</span>{{ formatCents(billingSummary.patientCents) }}</span>
            <span class="summary-metric"><span class="label">Paid</span>{{ formatCents(billingSummary.paidCents) }}</span>
            <span class="summary-ageing" *ngIf="billingSummary.outstandingCents > 0">
                <span class="label">Ageing</span>
                <span class="bucket" *ngIf="billingSummary.buckets.current">Cur {{ formatCents(billingSummary.buckets.current) }}</span>
                <span class="bucket b30" *ngIf="billingSummary.buckets.d30">30+ {{ formatCents(billingSummary.buckets.d30) }}</span>
                <span class="bucket b60" *ngIf="billingSummary.buckets.d60">60+ {{ formatCents(billingSummary.buckets.d60) }}</span>
                <span class="bucket b90" *ngIf="billingSummary.buckets.d90">90+ {{ formatCents(billingSummary.buckets.d90) }}</span>
                <span class="bucket b120" *ngIf="billingSummary.buckets.d120">120+ {{ formatCents(billingSummary.buckets.d120) }}</span>
            </span>
        </mat-panel-description>

    </mat-expansion-panel-header>
    <div class="panel-info">
        <ng-container *ngIf="procedureCodes; else listLoading">
            <ng-container *ngIf="procedureCodes.length; else noResults">
                <ng-container *ngFor="let group of filteredProcedureCodes">
                    <div class="list-header">
                        {{ group.date | date: 'longDate' }}
                    </div>
                    <mat-list class="full-width">
                        <mat-list-item (click)="loadCodeGroup(group.date, group.codes)" class="auto-height">
                            <div class="list-item">
                                <div class="list-item-details">
                                    <div matLine class="list-item-title">
                                        <div class="code-list">
                                            <span *ngFor="let code of group.codes; let last = last"
                                                  class="code-item"
                                                  [class.code-removed]="code.state?.removed"
                                                  [matTooltip]="providerTooltip.computedTooltip"
                                                  #providerTooltip="appProviderInitialsTooltip"
                                                  [appProviderInitialsTooltip]="code"
                                                  [existingTooltip]="getCodeTooltip(code)"
                                                  [showFinancialTooltip]="!stateUnit"
                                                  [matTooltipClass]="'financial-tooltip'">
                                                {{ code.code }}{{ !stateUnit && code.paidCash ? ' (Paid Up Front)' : '' }}{{ !stateUnit && code.noCharge ? ' (Pro Bono)' : '' }}<span class="code-chip code-chip--connect" *ngIf="code.state?.connectAdded">Connect</span><span class="code-chip" [ngClass]="chip.cls" *ngFor="let chip of code.state?.chips || []">{{ chip.label }}</span>{{ !last ? ', ' : '' }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="view-icon">
                                    <mat-icon>edit</mat-icon>
                                </div>
                            </div>
                        </mat-list-item>
                    </mat-list>
                </ng-container>
            </ng-container>
        </ng-container>
    </div>
</mat-expansion-panel>

<ng-template #startEndDateDialog>
    <h1 mat-dialog-title>Start/End Date Details</h1>
    <div mat-dialog-content>
        <div class="p-t-20">
            <mat-form-field appearance="outline" class="m-r-10">
                <mat-label>Start Date</mat-label>
                <input matInput [matDatepicker]="startDatePicker" [(ngModel)]="exportOptions.startDate"
                    placeholder="DD/MM/YYYY" [max]="maxDate">
                <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #startDatePicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>End Date</mat-label>
                <input matInput [matDatepicker]="endDatePicker" [(ngModel)]="exportOptions.endDate"
                    placeholder="DD/MM/YYYY">
                <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #endDatePicker></mat-datepicker>
            </mat-form-field>
        </div>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-button color="primary" [mat-dialog-close]="null">Cancel</button>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-raised-button color="primary" [mat-dialog-close]="exportOptions">{{ dateDialogConfirmLabel }}</button>
    </div>
</ng-template>

<ng-template #listLoading>
    <div class="list-loading">
        <mat-spinner color="primary" mode="indeterminate" diameter="20" style="float:right;"></mat-spinner>
    </div>
</ng-template>

<ng-template #noResults>
    <p class="no-records-message">No results found.</p>
</ng-template>